import React, { HTMLAttributes, ReactNode } from "react";
import classNames from "classnames";
import Styles from "./Details.module.scss";
import Text from "../text/Text";

interface DetailSectionProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
    title: ReactNode;
    children: ReactNode;
}

const DetailSection = React.forwardRef((
    args: DetailSectionProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const {
        title,
        children,
        className,
        ...rest
    } = args;
    return (
        <div className={classNames(className, Styles["details-section"])} {...rest} ref={ref}>
            <Text textVariant="body-2-medium" colorVariant="body-primary">
                {title}
            </Text>
            {children}
        </div>
    );
});
DetailSection.defaultProps = {
    className: undefined,
};

export default DetailSection;
